import { post } from '@/utils/request'

//获取目录
export function getList(data) {
    return post('psi/accessory/listAcc', data)
}
//修改
export function getEdit(data) {
    return post('psi/accessory/editAcc', data)
}
//添加
export function getAdd(data) {
    return post('psi/accessory/addAcc', data)
}
//删除
export function getDel(data) {
    return post('psi/accessory/delAcc', data)
}
//分类下拉
export function getOption(data) {
    return post('psi/classify/downward', data)
}
//商品id
export function getOption2(data) {
    return post('psi/commodity/xiala', data)
}
// 供应商id
export function getOption3(data) {
    return post('psi/vendor/xiala', data)
}
//详情
export function getInfo(data) {
    return post('psi/accessory/infoAcc', data)
}
//修改状态
export function getState(data) {
    return post('psi/accessory/upAcc', data)
}






